import React from "react";
import { motion } from "framer-motion";

export default function AppointmentContent({ mainColor, description }) {
    return (
        <div>
            <motion.div
                style={{ overflow: "hidden" }}
                initial="initial"
                animate="animate"
            >
                <motion.h2
                    className="heading"
                    style={{
                        color: mainColor,
                        display: "inline-block",
                    }}
                >
                    {"The Easiest Way to Book Your Appointment!"
                        .split(" ")
                        .map((word, index) => (
                            <motion.span
                                key={index}
                                style={{ display: "inline-block", marginRight: "6px" }}
                                initial={{ y: "100%", opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{
                                    ease: "easeOut",
                                    duration: 0.35,
                                    delay: index * 0.03,
                                }}
                            >
                                {word}
                            </motion.span>
                        ))}
                </motion.h2>
            </motion.div>

            <motion.div
                className="desc"
                style={{ overflow: "hidden", paddingBottom: "20px" }}
                initial="initial"
                animate="animate"
            >
                <motion.p
                    initial={{ y: "100%", opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{
                        ease: "easeOut",
                        duration: 0.35,
                        delay: 0.2,
                    }}
                >
                    {description}
                </motion.p>
            </motion.div>
        </div>
    );
}
